exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.youtubeTitle[data-v-2509ef06] {\n  color: #7b009c;\n}\n", ""]);

// exports
